import { gql, TypedDocumentNode } from "@apollo/client";

import { ModuleShare, MutationModuleShareArgs } from "types/generated";

type ShareModuleData = { moduleShare: Pick<ModuleShare, "id"> };

export const SHARE_MODULE: TypedDocumentNode<ShareModuleData, MutationModuleShareArgs> = gql`
  mutation ShareModule($id: ID!, $input: ModuleShareInput!) {
    moduleShare(id: $id, input: $input) {
      id
    }
  }
`;
